<!-- modal-v3 Backdrop -->
<div class="modal-v3-backdrop" *ngIf="isVisible" (click)="closeModalBox()">

  <!-- modal-v3 Dialog -->
  <div class="modal-v3-dialog" (click)="$event.stopPropagation()">

    @if(comment_type=='door') {
    <!-- Door Comments UI -->
    <div class="modal-v3-header">
      <h5 class="modal-v3-title">
        <mat-icon>chat_bubble</mat-icon>
        Door Operation Comments
      </h5>
      <div class="buttons-container">
        <button mat-raised-button color="primary" [disabled]="comment_type=='job'"
          (click)="changeCommentType('job')">Jobs</button>
        <button mat-raised-button color="primary" [disabled]="comment_type=='door'"
          (click)="changeCommentType('door')">Door</button>
        <button mat-raised-button color="primary" [disabled]="comment_type=='thresholds'"
          (click)="changeCommentType('thresholds')">Thresholds</button>
      </div>
      <div class="header-actions">
        <button type="button" class="btn-refresh" (click)="refreshComments()" [disabled]="isLoading"
          title="Refresh Comments">
          <mat-icon [class.spinning]="isLoading">refresh</mat-icon>
        </button>
        <button mat-icon-button (click)="closeModalBox()" style="display: flex; align-items: center;">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="modal-v3-body">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <div class="loading-spinner"></div>
        <p class="loading-text">Loading door comments...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="hasError && !isLoading" class="error-container">
        <div class="error-icon">
          <span>⚠️</span>
        </div>
        <h6 class="error-title">Error Loading Door Comments</h6>
        <p class="error-message">{{ errorMessage }}</p>
        <button class="btn btn-retry" (click)="refreshComments()">
          <span>🔄</span>
          Try Again
        </button>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && !hasError && comments.length === 0" class="empty-container">
        <div class="empty-icon">
          <span>💬</span>
        </div>
        <h6 class="empty-title">No Door Comments Found</h6>
        <p class="empty-message">There are no door operation comments for this oven yet.</p>
      </div>

      <!-- Comments Table -->
      <div *ngIf="!isLoading && !hasError && comments.length > 0" class="table-container">
        <div class="table-header">
          <h6 class="table-title">
            Door Comments History
            <span class="comment-count">({{ comments.length }} {{ comments.length === 1 ? 'comment' : 'comments'
              }})</span>
          </h6>
        </div>

        <div class="table-wrapper">
          <table class="comments-table">
            <thead>
              <tr>
                <th class="col-supervisor">
                  <!-- <span class="th-icon">👤</span> -->
                  Supervisor
                </th>
                <th class="col-datetime">
                  <!-- <span class="th-icon">📅</span> -->
                  Date & Time
                </th>
                <th class="col-datetime">
                  <!-- <span class="th-icon">📅</span> -->
                  Commented On
                </th>
                <th class="col-comment">
                  <!-- <span class="th-icon">💬</span> -->
                  Comment
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let comment of comments; let i = index" class="comment-row" [class.even]="i % 2 === 0">
                <td class="supervisor-cell">
                  <div class="supervisor-info">
                    <!-- <div class="supervisor-avatar">
                      {{ comment.supervisor_name.charAt(0).toUpperCase() }}
                    </div> -->
                    <span class="supervisor-name">{{ comment.supervisor_name }}</span>
                  </div>
                </td>
                <td class="datetime-cell">
                  <div class="datetime-info">
                    <div class="date-part">{{ formatDate(comment.time) }}</div>
                    <div class="time-part">{{ formatTime(comment.time) }}</div>
                  </div>
                </td>
                <td class="datetime-cell">
                  <div class="datetime-info">
                    <div class="date-part">{{ formatDate(comment.commented_on) }}</div>
                    <div class="time-part">{{ formatTime(comment.commented_on) }}</div>
                  </div>
                </td>
                <td class="comment-cell">
                  <div class="comment-content" [title]="comment.comment">
                    {{ comment.comment }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-v3-footer" *ngIf="!isLoading && !hasError && comments.length > 0">
      <div class="footer-info">
        <span class="info-icon">ℹ️</span>
        Showing {{ comments.length }} door operation {{ comments.length === 1 ? 'comment' : 'comments' }}
      </div>
      <button type="button" class="btn btn-close-footer" (click)="closeModalBox()">
        Close
      </button>
    </div>
    } @else if(comment_type=='job') {
    <!-- Job Comments UI -->
    <div class="modal-v3-header">
      <h5 class="modal-v3-title">
        <mat-icon>assignment</mat-icon>
        Job Comments
      </h5>
      <div class="buttons-container">
        <button mat-raised-button color="primary" [disabled]="comment_type=='job'"
          (click)="changeCommentType('job')">Jobs</button>
        <button mat-raised-button color="primary" [disabled]="comment_type=='door'"
          (click)="changeCommentType('door')">Door</button>
        <button mat-raised-button color="primary" [disabled]="comment_type=='thresholds'"
          (click)="changeCommentType('thresholds')">Thresholds</button>
      </div>
      <div class="header-actions">
        <button type="button" class="btn-refresh" (click)="refreshComments()" [disabled]="isLoading"
          title="Refresh Job Comments">
          <mat-icon [class.spinning]="isLoading">refresh</mat-icon>
        </button>
        <button mat-icon-button (click)="closeModalBox()" style="display: flex; align-items: center;">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="modal-v3-body">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <div class="loading-spinner"></div>
        <p class="loading-text">Loading job comments...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="hasError && !isLoading" class="error-container">
        <div class="error-icon">
          <span>⚠️</span>
        </div>
        <h6 class="error-title">Error Loading Job Comments</h6>
        <p class="error-message">{{ errorMessage }}</p>
        <button class="btn btn-retry" (click)="refreshComments()">
          <span>🔄</span>
          Try Again
        </button>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && !hasError && comments.length === 0" class="empty-container">
        <div class="empty-icon">
          <span>📋</span>
        </div>
        <h6 class="empty-title">No Job Comments Found</h6>
        <p class="empty-message">There are no comments for this job yet.</p>
      </div>

      <!-- Job Comments Table -->
      <div *ngIf="!isLoading && !hasError && comments.length > 0" class="table-container">
        <div class="table-header">
          <h6 class="table-title">
            Job Comments History
            <span class="comment-count">({{ comments.length }} {{ comments.length === 1 ? 'comment' : 'comments'
              }})</span>
          </h6>
        </div>

        <div class="table-wrapper">
          <table class="comments-table">
            <thead>
              <tr>
                <th class="col-supervisor">
                  Job Id
                </th>
                <th class="col-supervisor">
                  <!-- <span class="th-icon">👤</span> -->
                  Supervisor
                </th>
                <th class="col-datetime">
                  <!-- <span class="th-icon">📅</span> -->
                  Commented On
                </th>
                <th class="col-comment">
                  <!-- <span class="th-icon">💬</span> -->
                  Comment
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let comment of comments; let i = index" class="comment-row" [class.even]="i % 2 === 0">
                <td>
                  <div class="">{{comment.JOB_NO}}</div>
                </td>
                <td class="supervisor-cell">
                  <div class="supervisor-info">
                    <!-- <div class="supervisor-avatar">
                    {{ comment.supervisor_name.charAt(0).toUpperCase() }}
                  </div> -->
                    <span class="supervisor-name">{{ comment.supervisor_name }}</span>
                  </div>
                </td>
                <td class="datetime-cell">
                  <div class="datetime-info">
                    <div class="date-part">{{ formatDate(comment.commented_on || comment.time) }}</div>
                    <div class="time-part">{{ formatTime(comment.commented_on || comment.time) }}</div>
                  </div>
                </td>
                <td class="comment-cell">
                  <div class="comment-content" [title]="comment.comment">
                    {{ comment.comment }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-v3-footer" *ngIf="!isLoading && !hasError && comments.length > 0">
      <div class="footer-info">
        <span class="info-icon">ℹ️</span>
        Showing {{ comments.length }} job {{ comments.length === 1 ? 'comment' : 'comments' }}
      </div>
      <button type="button" class="btn btn-close-footer" (click)="closeModalBox()">
        Close
      </button>
    </div>
    } @else {
    <!-- Door Comments UI -->
    <div class="modal-v3-header">
      <h5 class="modal-v3-title">
        <mat-icon>chat_bubble</mat-icon>
        Threshold Operation Comments
      </h5>
      <div class="buttons-container">
        <button mat-raised-button color="primary" [disabled]="comment_type=='job'"
          (click)="changeCommentType('job')">Jobs</button>
        <button mat-raised-button color="primary" [disabled]="comment_type=='door'"
          (click)="changeCommentType('door')">Door</button>
        <button mat-raised-button color="primary" [disabled]="comment_type=='thresholds'"
          (click)="changeCommentType('thresholds')">Thresholds</button>
      </div>
      <div class="header-actions">
        <button type="button" class="btn-refresh" (click)="refreshComments()" [disabled]="isLoading"
          title="Refresh Comments">
          <mat-icon [class.spinning]="isLoading">refresh</mat-icon>
        </button>
        <button mat-icon-button (click)="closeModalBox()" style="display: flex; align-items: center;">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="modal-v3-body">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <div class="loading-spinner"></div>
        <p class="loading-text">Loading door comments...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="hasError && !isLoading" class="error-container">
        <div class="error-icon">
          <span>⚠️</span>
        </div>
        <h6 class="error-title">Error Loading Door Comments</h6>
        <p class="error-message">{{ errorMessage }}</p>
        <button class="btn btn-retry" (click)="refreshComments()">
          <span>🔄</span>
          Try Again
        </button>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && !hasError && comments.length === 0" class="empty-container">
        <div class="empty-icon">
          <span>💬</span>
        </div>
        <h6 class="empty-title">No Door Comments Found</h6>
        <p class="empty-message">There are no door operation comments for this oven yet.</p>
      </div>

      <!-- Comments Table -->
      <div *ngIf="!isLoading && !hasError && comments.length > 0" class="table-container">
        <div class="table-header">
          <h6 class="table-title">
            Thresholds Comment History
            <span class="comment-count">({{ comments.length }} {{ comments.length === 1 ? 'comment' : 'comments'
              }})</span>
          </h6>
        </div>

        <div class="table-wrapper">
          <table class="comments-table">
            <thead>
              <tr>
                <th class="col-supervisor">
                  <!-- <span class="th-icon">👤</span> -->
                  Supervisor
                </th>
                <th class="col-datetime">
                  <!-- <span class="th-icon">📅</span> -->
                  Date & Time
                </th>
                <th class="col-comment">
                  <!-- <span class="th-icon">💬</span> -->
                  Comment
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let comment of comments; let i = index" class="comment-row" [class.even]="i % 2 === 0">
                <td class="supervisor-cell">
                  <div class="supervisor-info">
                    <!-- <div class="supervisor-avatar">
                      {{ comment.supervisor_name.charAt(0).toUpperCase() }}
                    </div> -->
                    <span class="supervisor-name">{{ comment.supervisor_name }}</span>
                  </div>
                </td>
                <td class="datetime-cell">
                  <div class="datetime-info">
                    <div class="date-part">{{ formatDate(comment.commented_on) }}</div>
                    <div class="time-part">{{ formatTime(comment.commented_on) }}</div>
                  </div>
                </td>
                <td class="comment-cell">
                  <div class="comment-content" [title]="comment.comment">
                    {{ comment.comment }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-v3-footer" *ngIf="!isLoading && !hasError && comments.length > 0">
      <div class="footer-info">
        <span class="info-icon">ℹ️</span>
        Showing {{ comments.length }} thresholds operation {{ comments.length === 1 ? 'comment' : 'comments' }}
      </div>
      <button type="button" class="btn btn-close-footer" (click)="closeModalBox()">
        Close
      </button>
    </div>
    }

  </div>
</div>